(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.init(root);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var KEY = 'loopi.breadcrumb-click.v1';
  var TTL = 10 * 60 * 1000;

  function url(value, origin) {
    if (typeof value !== 'string' || !value || value[0] === '#') return null;
    try {
      var parsed = new URL(value, origin);
      return parsed.origin === origin && /^https?:$/.test(parsed.protocol) ? parsed : null;
    } catch (_) { return null; }
  }
  function collection(value, origin) {
    var parsed = url(value, origin);
    var match = parsed && parsed.pathname.match(/^(.*?)\/collections\/([^/]+)\/?$/);
    return match ? { handle: match[2], prefix: match[1], href: parsed.pathname + parsed.search } : null;
  }
  function product(value, origin) {
    var parsed = url(value, origin);
    var match = parsed && parsed.pathname.match(/^(.*?)(?:\/collections\/([^/]+))?\/products\/([^/]+)\/?$/);
    return match ? { handle: match[3], prefix: match[1], collection: match[2] } : null;
  }
  function read(storage) {
    try { return JSON.parse(storage.getItem(KEY)); } catch (_) { return null; }
  }
  function remember(storage, from, to, origin, now) {
    var source = collection(from, origin);
    var destination = product(to, origin);
    if (!source || !destination || source.prefix !== destination.prefix) return;
    try { storage.setItem(KEY, JSON.stringify({ product: destination.handle, source: source.href, time: now })); } catch (_) {}
  }
  function resolve(config, state) {
    var origin = state.origin;
    var rootCollection = collection(config.root.url, origin);
    var prefix = rootCollection ? rootCollection.prefix : '';
    var memberships = new Map();
    (config.collections || []).forEach(function (item) {
      var c = collection(item.url, origin);
      if (c && c.prefix === prefix && !memberships.has(c.handle)) memberships.set(c.handle, item);
    });
    function eligible(value) {
      var c = collection(value, origin);
      return c && c.prefix === prefix && (memberships.has(c.handle) || c.handle === 'all') ? c : null;
    }
    var rows = [];
    function flatten(nodes, parents) {
      (nodes || []).forEach(function (node, index) {
        var c = collection(node.url, origin);
        var children = node.children || [];
        var first = children[0] && collection(children[0].url, origin);
        var row = { title: node.title, collection: c, parents: parents, depth: parents.length,
          umbrella: index === 0 && parents.length > 0 && parents[parents.length - 1].group && nodes.length > 1 };
        row.group = !c;
        row.category = c || first;
        rows.push(row);
        flatten(children, parents.concat(row));
      });
    }
    flatten(config.menu, []);
    var selected = null;
    var currentProduct = product(state.href, origin);
    var ref = eligible(state.referrer);
    var record = state.record;
    var saved = record && record.product === (currentProduct && currentProduct.handle) &&
      Number.isFinite(record.time) && state.now >= record.time && state.now - record.time <= TTL ? eligible(record.source) : null;
    if (config.type === 'product') {
      if (currentProduct && currentProduct.collection) {
        selected = eligible(prefix + '/collections/' + currentProduct.collection);
        if (selected && ref && ref.handle === selected.handle) selected = ref;
        else if (selected && saved && saved.handle === selected.handle) selected = saved;
      } else {
        selected = ref || saved;
      }
      if (!selected) {
        var candidates = rows.filter(function (row) {
          return row.collection && row.collection.prefix === prefix && memberships.has(row.collection.handle) && row.collection.handle !== 'all';
        });
        candidates.sort(function (a, b) { return Number(a.umbrella) - Number(b.umbrella) || b.depth - a.depth; });
        if (candidates[0]) selected = candidates[0].collection;
      }
    } else if (config.type === 'collection') selected = collection(config.current.url, origin);

    var result = [{ title: config.root.title, url: config.root.url }];
    var seen = new Set(['all']);
    if (selected) {
      var match = rows.find(function (row) { return row.collection && row.collection.handle === selected.handle && row.collection.prefix === prefix; });
      if (match) match.parents.forEach(function (parent) {
        var c = parent.category;
        if (c && c.prefix === prefix && c.handle !== selected.handle && !seen.has(c.handle)) {
          result.push({ title: parent.title, url: c.href }); seen.add(c.handle);
        }
      });
      if (!seen.has(selected.handle)) {
        var member = memberships.get(selected.handle);
        result.push({ title: match ? match.title : member ? member.title : config.current.title, url: selected.href });
        seen.add(selected.handle);
      } else if (selected.handle === 'all' && config.type === 'product') result[0].url = selected.href;
    }
    if (config.type === 'collection') {
      result[result.length - 1].title = selected && selected.handle === 'all' ? config.root.title : config.current.title;
      result[result.length - 1].current = true;
    } else {
      result.push({ title: config.current.title, current: true });
    }
    return result;
  }
  function render(document, list, nodes) {
    list.replaceChildren();
    nodes.forEach(function (node) {
      var li = document.createElement('li');
      li.className = 'breadcrumb-delimeter';
      var crumb = document.createElement(node.current ? 'span' : 'a');
      crumb.className = 'breadcrumb-crumb';
      crumb.textContent = node.title;
      if (node.current) crumb.setAttribute('aria-current', 'page');
      else crumb.setAttribute('href', node.url);
      li.appendChild(crumb); list.appendChild(li);
    });
  }
  function init(window) {
    var document = window.document;
    function setup() {
      document.querySelectorAll('[data-logical-breadcrumbs]').forEach(function (nav) {
        var data = nav.querySelector('[data-breadcrumb-config]');
        if (!data) return;
        try {
          var config = JSON.parse(data.textContent);
          var storage;
          try { storage = window.sessionStorage; } catch (_) {}
          render(document, nav.querySelector('ol'), resolve(config, { origin: window.location.origin,
            href: window.location.href, referrer: document.referrer, record: read(storage), now: Date.now() }));
        } catch (_) {}
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', setup);
    function capture(event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor) return;
      try { remember(window.sessionStorage, window.location.href, anchor.href, window.location.origin, Date.now()); } catch (_) {}
    }
    document.addEventListener('click', capture, true);
    document.addEventListener('auxclick', capture, true);
  }
  return { resolve: resolve, remember: remember, read: read, render: render, init: init, TTL: TTL };
});
